import { Card } from '@repo/shadcn';

import { IwForm } from '@components/form';
import { HeaderBreadcrumb, SectionTitle } from '@components/ui';

import { Route } from '@/constants';

import {
    CreatePurchaseReturnProvider,
    useCreatePurchaseReturnContext,
} from './create-purchase-return.context';
import {
    CreatePurchaseReturnFormSchema,
    TCreatePurchaseReturnForm,
} from './create-purchase-return.schema';
import { PurchaseItems } from './purchase-items.component';
import { PurchaseOverview } from './purchase-overview';
import { PurchaseSelector } from './purchase-selector.component';

export const CreatePurchaseReturnComponent = () => {
    const { handleSubmit, formRef } = useCreatePurchaseReturnContext();
    return (
        <IwForm
            schema={CreatePurchaseReturnFormSchema}
            initialValues={{
                items: [],
                reason: '',
            }}
            onSubmit={(values) => {
                handleSubmit(values as TCreatePurchaseReturnForm);
            }}
            ref={formRef}
        >
            <Card className={'space-y-4 p-4'}>
                <div>
                    <HeaderBreadcrumb
                        items={[
                            { label: 'Purchases', href: Route.PURCHASES },
                            {
                                label: 'Purchase Returns',
                                href: Route.PURCHASE_RETURNS,
                            },
                            { label: 'Create Purchase Return' },
                        ]}
                    />
                </div>

                <SectionTitle>Create Purchase Return</SectionTitle>

                <PurchaseSelector />

                <div className={'grid grid-cols-[2fr_1fr] items-start gap-4'}>
                    <PurchaseItems />
                    <PurchaseOverview />
                </div>
            </Card>
        </IwForm>
    );
};

export const CreatePurchaseReturn = () => {
    return (
        <CreatePurchaseReturnProvider>
            <CreatePurchaseReturnComponent />
        </CreatePurchaseReturnProvider>
    );
};

CreatePurchaseReturn.displayName = 'CreatePurchaseReturn';
